import { EPrintActionTypes } from '../../actions/print';
import { TReduxActions } from '../../types/redux';
import { IPrintState } from '../../types/redux/print';

const defaultState = {
  isModalOpen: false,
  hideFavoriteEntities: [],
  options: {
    printPhoneNumbers: true,
    printNotes: true,
  },
};

export function printReducer(state: IPrintState = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EPrintActionTypes.SetOption:
      return {
        ...state,
        options: {
          ...state.options,
          [action.payload.optionName]: action.payload.value,
        },
      };

    case EPrintActionTypes.OpenModal:
      return {
        ...state,
        isModalOpen: true,
      };

    case EPrintActionTypes.CloseModal:
      return {
        ...state,
        isModalOpen: false,
      };

    case EPrintActionTypes.PrintHide:
      return {
        ...state,
        hideFavoriteEntities: state.hideFavoriteEntities.concat(action.entityId),
      };

    case EPrintActionTypes.PrintRestore:
      return {
        ...state,
        hideFavoriteEntities: state.hideFavoriteEntities.filter(entityId => entityId !== action.entityId),
      };

    default:
      return state;
  }
}
